import config from 'config';

import { getFilteredURLParams } from './getFilteredURLParams';

export const getContourAURL = () => {
  const filteredURLParams = getFilteredURLParams();
  return `${config.contourA}${!!filteredURLParams ? '?' : ''}${filteredURLParams}`;
};

export const getContourBURL = () => {
  const filteredURLParams = getFilteredURLParams();
  return `${config.contourB}${!!filteredURLParams ? '?' : ''}${filteredURLParams}`;
};

